import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {descriptorDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            descriptor: descriptorDefinition,
            dataObjectId: z.optional(z.string()),
        }),
    },
}
